/**
 * Implementation of IFloodgateStringProvider for Web SDK
 */

import { Api } from "@ms-ofb/floodgate-shared-typings";
import * as UIStrings from "./../UIStrings/UIStrings";
import * as Configuration from "./../Configuration/Configuration";


export default class FloodgateStringProvider implements Api.IFloodgateStringProvider {
	public loadStringResource(stringId: Api.FloodgateStringProviderStringType): string {
		const uiStrings = UIStrings.getUIStrings();

		switch (stringId) {
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue0): return uiStrings.Floodgate.Nps.Rating.Points11Value0;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue1): return uiStrings.Floodgate.Nps.Rating.Points11Value1;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue2): return uiStrings.Floodgate.Nps.Rating.Points11Value2;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue3): return uiStrings.Floodgate.Nps.Rating.Points11Value3;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue4): return uiStrings.Floodgate.Nps.Rating.Points11Value4;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue5): return uiStrings.Floodgate.Nps.Rating.Points11Value5;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue6): return uiStrings.Floodgate.Nps.Rating.Points11Value6;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue7): return uiStrings.Floodgate.Nps.Rating.Points11Value7;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue8): return uiStrings.Floodgate.Nps.Rating.Points11Value8;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue9): return uiStrings.Floodgate.Nps.Rating.Points11Value9;
			case (Api.FloodgateStringProviderStringType.Nps11RatingValue10): return uiStrings.Floodgate.Nps.Rating.Points11Value10;
			case (Api.FloodgateStringProviderStringType.Nps5RatingValue1): return uiStrings.Floodgate.Nps.Rating.Points5Value1;
			case (Api.FloodgateStringProviderStringType.Nps5RatingValue2): return uiStrings.Floodgate.Nps.Rating.Points5Value2;
			case (Api.FloodgateStringProviderStringType.Nps5RatingValue3): return uiStrings.Floodgate.Nps.Rating.Points5Value3;
			case (Api.FloodgateStringProviderStringType.Nps5RatingValue4): return uiStrings.Floodgate.Nps.Rating.Points5Value4;
			case (Api.FloodgateStringProviderStringType.Nps5RatingValue5): return uiStrings.Floodgate.Nps.Rating.Points5Value5;
			case (Api.FloodgateStringProviderStringType.NpsRatingQuestion): return uiStrings.Floodgate.Nps.Rating.Question;
			case (Api.FloodgateStringProviderStringType.NpsCommentQuestion): return uiStrings.Floodgate.Nps.Comment.Question;
			case (Api.FloodgateStringProviderStringType.NpsPromptNotNowLabel): return uiStrings.Floodgate.Nps.Prompt.No;
			case (Api.FloodgateStringProviderStringType.NpsPromptQuestion): return uiStrings.Floodgate.Nps.Prompt.Question;
			case (Api.FloodgateStringProviderStringType.NpsPromptTitle): return uiStrings.Floodgate.Nps.Prompt.Title;
			case (Api.FloodgateStringProviderStringType.NpsPromptYesLabel): return uiStrings.Floodgate.Nps.Prompt.Yes;
			default:
				return "";
		}
	}

	public getCustomString(str: string): string {
		return Configuration.get().getFloodgateInitOptions().uIStringGetter(str);
	}
}
